import React, { useState } from "react";
import "./FaqSection.css";

const FaqSection = () => {
  const [openItem, setOpenItem] = useState(null);

  const faqSections = [
    {
      title: "Membership FAQ",
      description: "Questions about Invescasa memberships.",
      items: [
        {
          question: "What membership options are available?",
          answer:
            "The Invescasa Platform Indicators currently offers two membership options: Free Membership and Premium Membership ($399 per year).",
        },
        {
          question: "What is included in the Free Membership?",
          answer:
            "The Free Membership allows users to explore selected property market indicators, introductory educational resources, limited market insights, and an overview of property cycle analysis.",
        },
        {
          question: "What is included in the Premium Membership ($399 per year)?",
          answer:
            "Premium members receive access to full real estate indicator datasets, market cycle analysis tools, suburb and market-level insights, affordability and price trend indicators, supply and demand metrics, and research insights.",
        },
        {
          question: "How much does the Premium Membership cost?",
          answer:
            "The Premium Membership costs $399 AUD per year paid on signing but billed annually and provides 12 months of full access to the platform.",
        },
        {
          question: "How do I pay for the Premium Membership?",
          answer:
            "Membership payments are processed securely through PIN Payments with payment services facilitated through Australia Post.",
        },
        {
          question: "Will I receive my own login portal?",
          answer:
            "Yes. All registered users receive their own secure login portal with individual login credentials.",
        },
      ],
    },
    {
      title: "Platform FAQ",
      description: "Questions about the Invescasa platform and indicators.",
      items: [
        {
          question: "What is the Invescasa Platform Indicators?",
          answer:
            "It is a proprietary data platform designed to help investors understand real estate market cycles, indicators, and macro trends across different locations.",
        },
        {
          question: "What problem does the platform solve?",
          answer:
            "The platform provides structured market intelligence by analysing real estate indicators such as supply vs demand, vacancy rates, population growth, affordability, infrastructure investment, and market cycle positioning.",
        },
        {
          question: "Who is the platform designed for?",
          answer:
            "It is designed for property investors, developers, buyer’s agents, real estate professionals, and data-driven researchers.",
        },
        {
          question: "How should investors use the indicators?",
          answer:
            "The indicators should be used as decision-support tools together with local property analysis, asset selection, risk tolerance, and investment strategy.",
        },
        {
          question: "Does the platform predict property prices?",
          answer:
            "No. The platform does not predict prices or guarantee outcomes. It identifies market conditions and structural trends.",
        },
        {
          question: "Does the platform provide investment advice?",
          answer:
            "No. The platform provides data and market insights only and does not constitute financial advice.",
        },
      ],
    },
  ];

  const toggleItem = (sectionIndex, itemIndex) => {
    const id = `${sectionIndex}-${itemIndex}`;
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-section__inner">
        <div className="faq-header">
          <h2 className="faq-title">Frequently asked questions</h2>
          <p className="faq-subtitle">
            Find answers to common questions about INVESCASA dashboards,
            features, services and setup.
          </p>
        </div>

        {faqSections.map((section, sectionIndex) => (
          <div className="faq-block" key={section.title}>
            <div className="faq-block__header">
              <h3 className="faq-block__title">{section.title}</h3>
              <p className="faq-block__description">{section.description}</p>
            </div>

            <div className="faq-grid">
              {section.items.map((faq, itemIndex) => {
                const id = `${sectionIndex}-${itemIndex}`;
                const isOpen = openItem === id;

                return (
                  <div
                    className={`faq-item ${isOpen ? "is-open" : ""}`}
                    key={faq.question}
                  >
                    <button
                      type="button"
                      className="faq-question"
                      onClick={() => toggleItem(sectionIndex, itemIndex)}
                      aria-expanded={isOpen}
                    >
                      <span>{faq.question}</span>
                      <span className="faq-icon" aria-hidden="true">
                        {isOpen ? "−" : "+"}
                      </span>
                    </button>

                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;